import { createGlobalStyle } from "styled-components";
import { theme, spacers } from "src/styles/theme";
import swiperStyle from "./swiper";
import FredokaRegular from 'assets/fonts/fredoka-v17-latin-regular.woff2';
import FredokaMedium from 'assets/fonts/fredoka-v17-latin-500.woff2';
import FredokaSemiBold from 'assets/fonts/fredoka-v17-latin-600.woff2';
import FredokaBold from 'assets/fonts/fredoka-v17-latin-700.woff2';
import WorkSansRegular from 'assets/fonts/work-sans-v24-latin-regular.woff2';
import WorkSansMedium from 'assets/fonts/work-sans-v24-latin-500.woff2';
import WorkSansSemiBold from 'assets/fonts/work-sans-v24-latin-600.woff2';
import MontserratMedium from "assets/fonts/Montserrat-Medium.woff2";
import MontserratSemiBold from "assets/fonts/Montserrat-SemiBold.woff2";
import MontserratExtraBold from "assets/fonts/Montserrat-ExtraBold.woff2";
import OpenSansRegular from "assets/fonts/OpenSans-Regular.woff2";
import OpenSansSemiBold from "assets/fonts/OpenSans-SemiBold.woff2";
import OpenSansBold from "assets/fonts/OpenSans-Bold.woff2";

export const GlobalStyle = createGlobalStyle`
  /* fredoka-regular - latin */
  @font-face {
    font-family: Fredoka;
    font-style: normal;
    font-weight: 400;
    src: url(${FredokaRegular}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* fredoka-500 - latin */
  @font-face {
    font-family: Fredoka;
    font-style: normal;
    font-weight: 500;
    src: url('${FredokaMedium}') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* fredoka-600 - latin */
  @font-face {
    font-family: Fredoka;
    font-style: normal;
    font-weight: 600;
    src: url('${FredokaSemiBold}') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* fredoka-700 - latin */
  @font-face {
    font-family: Fredoka;
    font-style: normal;
    font-weight: 700;
    src: url('${FredokaBold}') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* work-sans-regular - latin */
  @font-face {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 400;
    src: url(${WorkSansRegular}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* work-sans-500 - latin */
  @font-face {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    src: url(${WorkSansMedium}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }

  /* work-sans-600 - latin */
  @font-face {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    src: url(${WorkSansSemiBold}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  }
  
  @font-face {
    font-family: Montserrat;
    src: url(${MontserratMedium});
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: Montserrat;
    src: url(${MontserratSemiBold});
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: Montserrat;
    src: url(${MontserratExtraBold});
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: "Open Sans";
    src: url(${OpenSansRegular});
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "Open Sans";
    src: url(${OpenSansSemiBold});
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: "Open Sans";
    src: url(${OpenSansBold});
    font-weight: 700;
    font-style: normal;
  }

  /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  body {
    margin: 0;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  a {
    background-color: transparent;
  }

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  button,
  input { /* 1 */
    overflow: visible;
  }

  button,
  select { /* 1 */
    text-transform: none;
  }

  select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  option:not(:checked) {
    color: black; /* prevent <option>s from becoming transparent as well */
  }

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  progress {
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  input::placeholder {
    color: ${theme.colors.placeholder};
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  [type="search"] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  details {
    display: block;
  }

  summary {
    display: list-item;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none;
  }
  /* end reset */
  
  * {
    &,
    &::before,
    &::after {
      box-sizing: border-box;
      min-width: 0;
      min-height: 0;
    }
  }

  html {
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    color: ${theme.colors.text};
    font-family: ${theme.fonts.base};
    font-size: 62.5%;
    font-size: calc(1em * .625);
    line-height: ${theme.lineHeightBase};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html.no-scroll {
    overflow: hidden;
  }

  body {
    font-size: 1.6rem;
    min-height: 100%;
  }

  #root {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  p,
  address,
  ul,
  ol,
  dl,
  dd,
  blockquote,
  pre,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: ${spacers.md};
    margin-bottom: 0;

    &:first-child {
      margin-top: 0;
    }
  }

  img,
  table,
  td,
  blockquote,
  code,
  pre,
  textarea,
  input,
  video,
  svg {
    max-width: 100%;
  }

  img {
    height: auto;
    vertical-align: middle;
  }

  ul,
  ol {
    padding-left: ${spacers.md};
  }

  em,
  address,
  cite,
  i,
  var {
    font-style: italic;
  }

  blockquote,
  figure {
    margin-right: 0;
    margin-left: 0;
  }

  code,
  pre,
  samp,
  kbd {
    font-family: ${theme.fonts.monospace};
    line-height: inherit;
    white-space: pre-wrap;
  }
  
  .ReactModalPortal, .ReactModal__Overlay {
    z-index: 2;
  }

  ${swiperStyle}

  .print {
    display: none;
  }
  @media print {
    .print {
      display: block;
    }
    .screen {
      display: none;
    }
  }
`;
